const parseRequestHeaders = (
    headers?: HeadersInit | string
): HeadersInit => {
    console.log(headers);
    if (!headers) {
        return {};
    }

    if (typeof headers === 'object') {
        return headers;
    }

    if (typeof headers === 'string') {
        try {
            const parsed = JSON.parse(headers);

            if (parsed && typeof parsed === 'object') {
            return parsed as HeadersInit;
            }
        }  catch {
            return {};
        }
    }

    return {};
};

export { parseRequestHeaders };
